import { render, staticRenderFns } from "./MandateView.vue?vue&type=template&id=72c37a0a&scoped=true&"
import script from "./MandateView.vue?vue&type=script&lang=ts&"
export * from "./MandateView.vue?vue&type=script&lang=ts&"
import style0 from "./MandateView.vue?vue&type=style&index=0&id=72c37a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c37a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
